import "./src/styles/global.css";
import {
  initializeGoogleTag,
  trackGooglePageView,
} from "./src/utils/google-tag";
import {
  initializeSignupAttribution,
  syncSignupAttribution,
  startSignupLinkSync,
} from "./src/utils/signup-attribution";

export {
  wrapRootElement,
  wrapPageElement,
} from "./src/components/website-status/wrappers";

export const onClientEntry = () => {
  initializeSignupAttribution();
};

export const onInitialClientRender = () => {
  initializeGoogleTag();
  startSignupLinkSync();
  trackGooglePageView(window.location);
};

export const onRouteUpdate = ({ location }) => {
  syncSignupAttribution(location);
  trackGooglePageView(location);
};
